<div class="container-fluid">
  <div class="py-5 text-center">
    <h2>{{ 'TERMS_SERVICE.TERMS_OF_SERVICE' | transloco }}</h2>
    <p class="lead">{{ 'TERMS_SERVICE.READ_TERMS_OF_SERVICE' | transloco }}</p>
    <button mat-raised-button routerLink="/flygets-start">{{ 'FLYGETS.PRICES.BACK' | transloco | uppercase}}</button>
  </div>
</div>

<div class="container-fluid">
  <div class="py-5 text-left">
    <p>1. {{ 'TERMS_SERVICE.1' | transloco }}</p>
    <p>2. {{ 'TERMS_SERVICE.2' | transloco }}</p>
    <p>3. {{ 'TERMS_SERVICE.3' | transloco }}</p>
    <p>4. {{ 'TERMS_SERVICE.4' | transloco }}</p>
    <p>5. {{ 'TERMS_SERVICE.5' | transloco }}</p>
    <p>6. {{ 'TERMS_SERVICE.6' | transloco }}</p>
    <p>7. {{ 'TERMS_SERVICE.7' | transloco }}</p>
    <p>8. {{ 'TERMS_SERVICE.8' | transloco }}</p>
    <p>9. {{ 'TERMS_SERVICE.9' | transloco }}</p>
    <p>{{ 'TERMS_SERVICE.NOTE' | transloco }}</p>
    <p>10. {{ 'TERMS_SERVICE.10' | transloco }}</p>
    <p>11. {{ 'TERMS_SERVICE.11' | transloco }}</p>
    <p>12. {{ 'TERMS_SERVICE.12' | transloco }}</p>
    <p>13. {{ 'TERMS_SERVICE.13' | transloco }}</p>
    <p>14. {{ 'TERMS_SERVICE.14' | transloco }}</p>
    <p>15. {{ 'TERMS_SERVICE.15' | transloco }}</p>
    <p>16. {{ 'TERMS_SERVICE.16' | transloco }}</p>
    <p>17. {{ 'TERMS_SERVICE.17' | transloco }}</p>
    <p>18. {{ 'TERMS_SERVICE.18' | transloco }}</p>
  </div>
</div>

<app-small-footer></app-small-footer>